






import Vue, { PropType } from 'vue';

export enum NeonButtonVariant {
  Default = 'default',
  Media = 'media',
  Technology = 'technology'
}

export default Vue.extend({
  name: 'NeonButton',
  props: {
    label: {
      type: String,
      default: 'I need a label :(',
      required: true,
    },
    variant: {
      type: String as PropType<NeonButtonVariant>,
      default: () => NeonButtonVariant.Default.toString(),
      validator: (value: string) => [
        NeonButtonVariant.Default.toString(),
        NeonButtonVariant.Media.toString(),
        NeonButtonVariant.Technology.toString(),
      ].indexOf(value) !== -1,
    },
    onClick: {
      type: Function,
      required: true,
    },
  },
  computed: {
    classes() {
      return {
        root: true,
        'media-pink': this.variant === NeonButtonVariant.Media.toString(),
        'tech-green': this.variant === NeonButtonVariant.Technology.toString(),
      };
    },
  },
});
